import MabraButtonTheme from '@/mabra/components/Button/theme';

export default MabraButtonTheme;
